
import Wind from "../../../assets/filled/Wind.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WindIcon({ className, dataTestid = "WindIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Wind data-testid={dataTestid} className={classes} {...rest} />
  );
}
